// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c3a9d0e","952":"fd2772cb"}[chunkId] + ".chunk.js";
};